var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$route.name === "user-profile" &&
    !_vm.requestData.respuestaAvanzada.activa
      ? _c("div", [
          _c("p", { staticClass: "message-info" }, [
            _vm._v(
              " Sin firma configurada dentro de la empresa, contáctese con su administrador "
            )
          ])
        ])
      : _vm._e(),
    !_vm.exitMessage
      ? _c(
          "div",
          { class: { "sign-container": _vm.$route.name === "user-profile" } },
          [
            _c("h5", { staticClass: "message mb-5" }, [
              _vm._v(
                " La contraseña ingresada se utiliza para firmar documentos y el nombre identificador se necesita para poder encontrar el certificado en Ministerio de Economía. "
              )
            ]),
            _vm.requestData.id
              ? _c(
                  "div",
                  { staticClass: "row mb-2" },
                  [
                    _c("vs-icon", {
                      staticClass: "col-1",
                      attrs: { icon: "adjust" }
                    }),
                    _c("label", { staticClass: "col-3 text-left" }, [
                      _vm._v("Estado de firma:")
                    ]),
                    _vm.$route.name === "users-management"
                      ? _c("b-form-checkbox", {
                          staticClass: "col-1 ml-4",
                          model: {
                            value: _vm.signData.active,
                            callback: function($$v) {
                              _vm.$set(_vm.signData, "active", $$v)
                            },
                            expression: "signData.active"
                          }
                        })
                      : _vm._e(),
                    _c("label", { staticClass: "col-2 text-left" }, [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.signData.active ? "Activa" : "Inactiva") +
                          ")"
                      )
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "row mb-2" },
              [
                _c("vs-icon", {
                  staticClass: "col-1",
                  attrs: { icon: "fingerprint" }
                }),
                _c("label", { staticClass: "col-3 text-left" }, [
                  _vm._v("Nombre identificador:")
                ]),
                _c(
                  "div",
                  { staticClass: "col-8" },
                  [
                    _c("b-form-select", {
                      attrs: {
                        options: _vm.getSigners,
                        disabled: _vm.$route.name === "user-profile",
                        state:
                          _vm.$route.name === "users-management"
                            ? _vm.validateIndentifier
                            : null
                      },
                      model: {
                        value: _vm.signData.userSignature,
                        callback: function($$v) {
                          _vm.$set(_vm.signData, "userSignature", $$v)
                        },
                        expression: "signData.userSignature"
                      }
                    }),
                    _vm.$route.name === "users-management"
                      ? _c(
                          "b-form-invalid-feedback",
                          { attrs: { state: _vm.validateIndentifier } },
                          [_vm._v(" El identificador es obligatorio ")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row mb-4" },
              [
                _c("vs-icon", {
                  staticClass: "col-1",
                  attrs: { icon: "lock" }
                }),
                _c("label", { staticClass: "col-3 text-left" }, [
                  _vm._v("Contraseña certificado:")
                ]),
                _c(
                  "div",
                  { staticClass: "col-8" },
                  [
                    _c("b-form-input", {
                      attrs: {
                        maxlength: "100",
                        state:
                          _vm.$route.name === "user-profile"
                            ? _vm.validatePassword
                            : null,
                        disabled: _vm.$route.name === "users-management",
                        type: "password"
                      },
                      model: {
                        value: _vm.signData.hash,
                        callback: function($$v) {
                          _vm.$set(_vm.signData, "hash", $$v)
                        },
                        expression: "signData.hash"
                      }
                    }),
                    _vm.$route.name === "user-profile"
                      ? _c(
                          "b-form-invalid-feedback",
                          { attrs: { state: _vm.validatePassword } },
                          [_vm._v(" Mínimo 6 caracteres ")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row d-block text-center" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      disabled: _vm.loading,
                      variant: _vm.signData.id ? "primary" : "warning"
                    },
                    on: { click: _vm.saveSignature }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.signData.id ? "Guardar cambios" : "Activar firma"
                        ) +
                        " "
                    ),
                    _vm.loading
                      ? _c("b-spinner", {
                          attrs: { small: "", variant: "primary" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.exitMessage && _vm.$route.name === "users-management",
            expression: "exitMessage && $route.name === 'users-management'"
          }
        ],
        staticClass: "text-center alert alert-success p-3",
        attrs: { role: "alert" }
      },
      [
        _vm._v(
          " Identificador de firma grabado exitosamente. Puede cerrar esta ventana "
        )
      ]
    ),
    _vm.requestData.id && _vm.$route.name === "user-profile"
      ? _c(
          "div",
          { staticClass: "mt-4" },
          [
            _c("ConfigureStamp", {
              attrs: {
                prefix: "ecert",
                proveedor: "FirmadorMinisterioEconomia",
                tipoFirma: "firmaAvanzada",
                user: _vm.user,
                customConfigIds: {
                  tipo: "io.febos.ecert.tipo",
                  plantilla: "io.febos.ecert.plantilla",
                  imagen: "io.febos.ecert.imagen",
                  background: "io.febos.ecert.background",
                  representacion: "io.febos.ecert.representacion",
                  alto: "io.febos.ecert.alto",
                  ancho: "io.febos.ecert.ancho"
                }
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }